import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_financials/pnl-report")({
  beforeLoad: ({ context }) => guardRoute(context.me, "pnl-report"),
  component: Outlet,
});
